<template>
    <div class="approve-main">
        <div class="approve-btn">
            <el-button type = "primary" @click="addApproveRule" v-if="!singleNode">新增审批节点</el-button>
            <el-button type="primary" @click="saveApproveRule">保存</el-button>
        </div>
        <div class="approve-content">
            <div class="approve-content-item" v-for="(item,index) in approvePeopleList" :key="index">
               <div class="approve-order"  v-if="!singleNode">
                   审批顺序{{item.approveOrder}}
               </div>
               <div class="approve-way">
                   审批方式
                   <el-select v-model="item.approveWay" placeholder="请选择审批方式">
                      <el-option
                        v-for="item in approveWay"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                       >
                      </el-option>
                   </el-select>
               </div>
               <div v-if="item.approveWay==2" class="approve-proportion">
                   会签比例
                   <el-input-number
                        v-model="item.proportion"
                        :precision="0" :step="1" :min="0" :max="100"
                        placeholder="会签比例"
                        >
                   </el-input-number>
               </div>
               <div class="approve-people">
                   <div class="approve-people-btn">
                       <el-dropdown @command="handleCommand">
                         <el-button>
                            添加审批人员<i class="el-icon-arrow-down el-icon--right"></i>
                         </el-button>
                         <el-dropdown-menu  split-button slot="dropdown">
                           <el-dropdown-item :command="beforeHandleCommand(item,'1')">人员列表</el-dropdown-item>
                           <el-dropdown-item :command="beforeHandleCommand(item,'2')">表单字段</el-dropdown-item>
                         </el-dropdown-menu>
                       </el-dropdown>
                   </div>
                   <div class="approve-people-list">
                        <div class="tag-item" v-for="(people,ind) in item.approvePeoples" :key="ind">
                            <el-tag v-if="people.approvePeopleType=='user'">{{people.selectedUserName}}</el-tag>
                            <el-tag v-if="people.approvePeopleType=='formField'" type="warning">{{people.fieldName}}</el-tag>
                        </div>
                   </div>
               </div>
               <div class="opera-btn"  v-if="!singleNode">
                  <i class="el-icon-delete" @click="delApprovePeople(item)"></i>
               </div>
            </div>
        </div>
        <el-dialog
            title="选择审批人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowUserOrg"
            v-if="isShowUserOrg"
            append-to-body
          >
          <UserOrg  :key="loadTimer" ref="userOrg" :multiple="true" :selectedUser="selectedUser" :canDrop="true" />
          <span slot="footer" class="dialog-footer">
              <el-button  type="primary" @click="confirmClick()">确定</el-button>
              <el-button @click="isShowUserOrg = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog
            title="选择表单字段人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowFormFieldList"
            v-if="isShowFormFieldList"
            append-to-body
          >
          <el-select v-model="selectedField" multiple placeholder="请选择字段">
              <el-option-group
                v-for="group in fieldOptions"
                :key="group.label"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-option-group>
            </el-select>

          <span slot="footer" class="dialog-footer">
              <el-button  type="primary" @click="setFormField()">确定</el-button>
              <el-button @click="isShowFormFieldList = false">取 消</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    export default{
        data () {
            return {
                approvePeopleList: [],
                approveWay: [
                    {
                        value: 1,
                        label: '或签'
                    },
                    {
                        value: 2,
                        label: '会签'
                    }
                ],
                isShowUserOrg: false,
                isShowFormFieldList: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                loadTimer: '',
                selectUsers: [],
                curObj: {},
                fieldOptions: [],
                userFieldList: [],
                selectedField: []
            };
        },
        props: {
            forms: {
                type: Array
            },
            approvePeopleArray: {
                type: Array
            },
            singleNode: {
                type: Boolean
            }
        },
        created () {
            this.approvePeopleList = this.approvePeopleArray;
        },
        methods: {
            addApproveRule () {
                let approveOrder = this.approvePeopleList.length + 1;
                let approveItem = {};
                approveItem.approveOrder = approveOrder;
                approveItem.approveWay = 1;
                approveItem.id = this.generateUUID();
                this.approvePeopleList.push(approveItem);
            },
            beforeHandleCommand (obj, index) {
                return {
                    'data': obj,
                    'command': index
                };
            },
            initFormFieldList () {
                let options = [];
                this.userFieldList = [];
                this.selectedField = [];
                let selectedUserIds = [];
                let selectedUserNames = [];
                for (let i = 0; i < this.forms.length; i++) {
                    let cur = this.forms[i];
                    let formName = cur.modelName;
                    let fieldsList = cur.fieldsList;
                    let optionsItem = {};
                    let itemOptions = [];
                    for (let j = 0; j < fieldsList.length; j++) {
                        let itemCur = fieldsList[j];
                        if (itemCur.type == 'user') {
                            itemCur.formId = cur.id;
                            itemOptions.push(itemCur);
                            this.userFieldList.push(itemCur);
                        }
                    }
                    if (itemOptions.length > 0) {
                        optionsItem.options = itemOptions;
                        optionsItem.label = formName;
                        optionsItem.formId = cur.id;
                        options.push(optionsItem);
                    }
                }
                this.fieldOptions = options;
                this.approvePeopleList.forEach(item => {
                    if (item.id == this.curObj.id) {
                        if (!item.approvePeoples) {
                            item.approvePeoples = [];
                        }
                        item.approvePeoples.forEach(obj => {
                            if (obj.approvePeopleType == 'formField') { // 表单内字段
                                this.selectedField.push(obj.id);
                            } else if (obj.approvePeopleType == 'user') {
                                selectedUserIds.push(obj.selectedUserId);
                                selectedUserNames.push(obj.selectedUserName);
                            }
                        });
                    }
                });
                this.selectedUser = {selectedUserIds: selectedUserIds.join(','), selectedUserNames: selectedUserNames.join(',')};
            },
            handleCommand (obj) {
                this.curObj = obj.data;
                // 人员字段和表单字段统统初始化
                this.initFormFieldList();
                if (obj.command == '1') {
                    this.selectedUser = {};
                    setTimeout(() => { // 初始化
                        this.$refs.userOrg._initPage();
                    }, 0);
                    this.isShowUserOrg = true;
                } else if (obj.command == '2') {
                    this.isShowFormFieldList = true;
                }
            },
            confirmClick () {
                this.setApprovePeople();
                this.isShowUserOrg = false;
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            setApprovePeople () {
                this.approvePeopleList.forEach(item => {
                    if (item.id == this.curObj.id) {
                        item.approvePeoples = [];// 置空审批人
                        let approveUsersArry = this.addUserField();// 增加人员字段到审批人
                        let selectedFieldObj = this.addFieldField();// 增加表单字段到审批人
                        if (approveUsersArry.length > 0) {
                            item.approvePeoples.push(...approveUsersArry);
                        }
                        if (selectedFieldObj.length > 0) {
                            item.approvePeoples.push(...selectedFieldObj);
                        }
                    }
                });
            },
            addUserField () {
                let approveUsersArry = [];
                if (this.$refs.userOrg) {
                    this.$refs.userOrg.setChoosedUser();
                }
                this.selectUsers = [];
                this.selectUsers = this.selectedUser.selectedUserNames.split(',');
                let selectedUserIds = this.selectedUser.selectedUserIds.split(',');
                let selectedUserNames = this.selectedUser.selectedUserNames.split(',');
                // let approvePeoples = [];
                for (let i = 0; i < selectedUserIds.length; i++) {
                    let selectedUserId = selectedUserIds[i];
                    if (selectedUserId.length > 2) {
                        let selectedUserName = selectedUserNames[i];
                        let curObj = {};
                        curObj.selectedUserId = selectedUserId;
                        curObj.selectedUserName = selectedUserName;
                        curObj.approvePeopleType = 'user';
                        approveUsersArry.push(curObj);
                    }
                }
                return approveUsersArry;
            },
            addFieldField () {
                let selectedFieldObj = [];
                for (let i = 0; i < this.userFieldList.length; i++) {
                    let cur = this.userFieldList[i];
                    for (let j = 0; j < this.selectedField.length; j++) {
                        if (this.selectedField[j] == cur.id) {
                            let item = {};
                            item.id = cur.id;
                            item.modelId = cur.modelId;
                            item.fieldName = cur.name;
                            item.formId = cur.formId;
                            item.approvePeopleType = 'formField';
                            selectedFieldObj.push(item);
                        }
                    }
                }
                return selectedFieldObj;
            },
            setFormField () {
                this.setApprovePeople();
                this.isShowFormFieldList = false;
            },
            delApprovePeople (obj) {
                for (let k = 0; k < this.approvePeopleList.length; k++) {
                    let cur = this.approvePeopleList[k];
                    if (cur.id == obj.id) {
                        this.approvePeopleList.splice(k, 1);
                    }
                }
                for (let i = 0; i < this.approvePeopleList.length; i++) { // 排序
                    let cur = this.approvePeopleList[i];
                    if (i == 0) {
                        cur.approveOrder = 1;
                    } else {
                        let curLast = this.approvePeopleList[i - 1];
                        cur.approveOrder = curLast.approveOrder + 1;
                    }
                }
            },
            saveApproveRule () {
                this.$emit('saveApproveRule', this.approvePeopleList);
            }
        }
    };
</script>

<style lang="less">
    .approveSetNode{
        height: 80%;
        .el-dialog__body{
            height: 100%;
            padding: 10px 10px;
            .approve-main{
                height: 100%;
                width: 100%;
                overflow: auto;
                .approve-btn{
                    width: 100%;
                    text-align: right;
                    height: 40px;
                    line-height: 40px;
                }
                .approve-content{
                    width: 100%;
                    .approve-content-item{
                        display: flex;
                        width: 100%;
                        height: 60px;
                        line-height: 60px;
                        .approve-order{
                            width: 80px;
                        }
                        .approve-way{
                           width: 280px;
                        }
                        .approve-proportion{
                             width: 220px;
                        }
                        .approve-people{
                            flex: 1;
                            display: flex;
                            .approve-people-btn{
                                width: 140px;
                               .el-dropdown{
                                   line-height:0px;
                               }
                            }
                            .approve-people-list{
                                flex: 1;
                                display: flex;
                                .tag-item{
                                    margin-right: 4px;
                                }
                            }
                        }
                        .opera-btn{
                            width: 40px;
                            .el-icon-delete{
                                cursor: pointer;
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessTemplate/ApprovePeopleRule.vue